/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WongBakersPainScore from './wong-bakers-pain-score';
import WongBakersPainScoreDetail from './wong-bakers-pain-score-detail';
import WongBakersPainScoreUpdate from './wong-bakers-pain-score-update';
import WongBakersPainScoreDeleteDialog from './wong-bakers-pain-score-delete-dialog';

const WongBakersPainScoreRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WongBakersPainScore />} />
    <Route path="new" element={<WongBakersPainScoreUpdate />} />
    <Route path=":id">
      <Route index element={<WongBakersPainScoreDetail />} />
      <Route path="edit" element={<WongBakersPainScoreUpdate />} />
      <Route path="delete" element={<WongBakersPainScoreDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WongBakersPainScoreRoutes;
